<template>
  <div class="mode2 noSelect">
    <div class="import-main">
<!--      <div class="import-left">-->
<!--        <img class="import-image" src="/theme/style2/static/images/icons/import.png" alt="">-->
<!--        <p class="import-tips">将文件拖拽至框内上传</p>-->
<!--        <a class="import-btn" href="javascript:void(0);">-->
<!--          <img class="import-btn-icon" src="/theme/style2/static/images/icons/shangchuan@2x.png" alt="">-->
<!--          <span>上传文件</span>-->
<!--        </a>-->
<!--      </div>-->
      <el-upload
          :data="uploadData"
          :limit="1"
          :multiple="false"
          :action="API_URL+'/fileupload'"
          :on-success="uploadHandleSuccess"
          :before-upload="beforeUpload"
          class="upload-demo"
          list-type=""
          drag
          multiple>
        <i class="el-icon-upload"/>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>


      <div class="import-right">
        <p class="import-text">注意事项：</p>
        <p class="import-text">1、仅支持XLXS、XLS文件</p>
        <p class="import-text">2、文件大小限制在5M以内</p>

        <div class="import-content">
          <div class="import-item">
            <img class="import-item-icon" :src="`${IMG_URL}images/icons/icon1.png`" alt="">
            <a :href="`${IMG_URL}gifttpl.xlsx`">下载模板</a>
            <a :href="`${IMG_URL}gifttpl-why.xlsx`">下载无货源模板</a>
          </div>
          <div class="import-item">
            <img class="import-item-icon" :src="`${IMG_URL}images/icons/icon2.png`" alt="">
            <a href="javascript:void(0);">查看视频教程</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getToken} from "@/api/auth"
export default {
  name: "mode2",
  data(){
    return{
      uploadData: {},
    }
  },
  mounted(){
    this.uploadData = {
      token: getToken()
    }
  },
  methods:{
    // 导入
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('文件大小不能超过5MB')
        return false
      }
    },
    uploadHandleSuccess(response, file, fileList) {
      const list = []
      this.addressData = []
      response.data.forEach(item => {
        console.log(item)
        list.push(item)
      })
      // this.address_msg = '上传成功 ' + list.length + ' 条'
      this.addressData = list;
      this.$emit("onAddress", {data: this.addressData, error_qty: 0, ok_qty: 0})
    },
  }
}
</script>

<style scoped lang="scss">
.mode2{
  margin-bottom: 20px;

  .import-main{
    display: flex;
    align-items: center;
    justify-content: space-between;

    .import-left{
      height: 300px;
      border: 1px dashed #999999;
      width: 50%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;

      &:hover{
        border-color: #0f375a;
      }

      .import-image{
        height: 160px;
        width: auto;
      }
      .import-tips{
        font-weight: bold;
        color: #000000;
        font-size: 12px;
      }
      .import-btn{
        width: 120px;
        height: 40px;
        background-color: #0f375a;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;

        .import-btn-icon{
          height: 14px;
          margin-right: 3px;
        }
      }
    }
    .import-right{
      width: 450px;
      height: 300px;
      background-color: #F2F2F2;
      padding: 40px;

      p{
        margin: 0 0 5px;
        color: #000000;
      }

      .import-content{
        margin-top: 30px;

        .import-item{
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          .import-item-icon{
            height: 34px;
          }

          a{
            color: #000000;
            margin-left: 10px;
            font-size: 12px;
            font-weight: bold;
            text-decoration:underline
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/order/components/mode/mode_2.vue